import { render, staticRenderFns } from "./RegisterInform.vue?vue&type=template&id=4e3a0e73"
import script from "./RegisterInform.vue?vue&type=script&lang=js"
export * from "./RegisterInform.vue?vue&type=script&lang=js"
import style0 from "./RegisterInform.vue?vue&type=style&index=0&id=4e3a0e73&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports